import { useEffect, useState } from 'react';
import { fetchCategories, DEFAULT_VIDEO_CATEGORIES } from '../lib/categories';

// Subscribers re-render when categories are refreshed elsewhere
const listeners = new Set();
export const notifyCategoriesChanged = () => listeners.forEach(fn => fn());

export const useCategories = () => {
  const [items, setItems] = useState(DEFAULT_VIDEO_CATEGORIES);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      const list = await fetchCategories();
      if (!cancelled) {
        setItems(list);
        setLoading(false);
      }
    };
    load();
    const refresh = async () => {
      const list = await fetchCategories();
      if (!cancelled) setItems(list);
    };
    listeners.add(refresh);
    return () => { cancelled = true; listeners.delete(refresh); };
  }, []);

  const getLabel = (value, lang) => {
    const c = items.find(x => x.value === value);
    if (!c) return value;
    return lang === 'ar' ? c.ar : c.en;
  };

  return { categories: items, loading, getLabel };
};
